export enum SEARCH_EVENT_TYPE {
    AUTHOR_SEARCH = 'authorSearch',
    MATERIAL_BY_ID_SEARCH = 'materialByIdSearch',
    SUGGESTION_SEARCH = 'selectedSearchSuggestion',
}

export enum SEARCH_INPUT_TYPE {
    SUGGESTION = 'suggestion',
    COPIED = 'copied',
    TYPED = 'typed'
}

export enum SOURCE_PAGE_TYPE {
    SEARCH_RESULTS = 'search_results',
    MATERIAL_PAGE = 'material_page',
    AUTHOR_PAGE = 'author_page',
    HOME_PAGE = 'home_page',
    SUBJECT_PAGE = 'subject_page',
    OTHER = 'other'
}
